// extracted by mini-css-extract-plugin
export default {"tagWrapper":"ContractorView_tagWrapper__PSRlK","headerDescriptionsRow":"ContractorView_headerDescriptionsRow__6bQF3"};